module.exports = __webpack_public_path__ + "img/img108.399f895d.svg";